import type { Environment } from './environment.type'

export const environment = {
    production: false,
    apiBaseUrl: 'https://nav-backend.ei-poc.study',
    apiUrl: 'https://nav-backend.ei-poc.study',
    ssoBaseUrl: 'https://accounts-dev.ei-poc.study',
    s3Bucket: 'test-core-common-utils-service-1',
    name: undefined,
    enableLog: undefined,
    logLevel: undefined,
    logEndpoint: undefined,
    features: undefined,
    assetsBucketUrl: undefined,
    commonLoginUrl: undefined,
    version: undefined,
} as Environment
